import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group-modal-withdraw',
  templateUrl: './banker-group-modal-withdraw.component.html',
  styleUrls: ['./banker-group-modal-withdraw.component.scss']
})
export class BankerGroupModalWithdrawComponent implements OnInit {

  public data: any = {};
  @Input() banker_group_uuid: string;
  @Output() closeEvent = new EventEmitter<boolean>();
  public banks: any = [];
  public is_loading_function:boolean = false;
  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    let rtn:any = await this.http.post("/admin/adjustment-init")
    this.banks = rtn.banks;
  }

  close() {
    this.closeEvent.emit(false);
  }

  async submit() {
    this.is_loading_function = true;
    this.data.banker_group_uuid = this.banker_group_uuid;
    let rtn:any = await this.http.post("/admin/banker-group/withdraw", this.data);

    if(rtn.status) {
      this.closeEvent.emit(true);
    }
    this.is_loading_function = false;
    if(!rtn.status && rtn.message) {
      this.http.notify(rtn.message);
      return;
    }
  }

}
